export default __webpack_public_path__ + "static/media/constellation.11ef5b3a.png";